import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "panel p-bottom-4",
  "data-cy": "request-tags"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "panel-heading has-background-light has-text-weight-semibold is-size-4" }, " Tags ", -1)
const _hoisted_3 = {
  key: 0,
  class: "panel-content"
}
const _hoisted_4 = { class: "panel-section p-bottom-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold" }, "Assigned tags", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "is-italic m-bottom-12"
}
const _hoisted_8 = {
  key: 0,
  class: "help"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "/admin/tags" }, "tag page", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrTag = _resolveComponent("NrTag")!
  const _component_NrLoadingAnimation = _resolveComponent("NrLoadingAnimation")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    (!_ctx.filteredRequestLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["panel-item is-flex is-align-items-center is-justify-content-space-between", { 'panel-item--editable': $options.canUpdateRequest }])
            }, [
              _hoisted_5,
              ($options.canUpdateRequest)
                ? (_openBlock(), _createBlock(_component_NrTooltip, {
                    key: 0,
                    label: "Edit request tags"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NrIconButton, {
                        variant: "minimal-neutral",
                        icon: { name: 'pencil-alt', type: 'regular' },
                        "aria-label": "Edit request tags",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.toggleModal(true)))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          ($props.tags.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tags, (tag, index) => {
                  return (_openBlock(), _createBlock(_component_NrTag, {
                    class: "m-right-8 m-top-8",
                    key: index,
                    label: tag.name,
                    size: "normal",
                    tagColor: "purple"
                  }, null, 8, ["label"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_7, "No tags assigned"))
        ]))
      : (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
          key: 1,
          count: 3
        })),
    _createVNode(_component_NrModal, {
      title: "Change tags",
      show: $data.showModal,
      hasSecondaryButton: true,
      disableButtons: $data.updating,
      secondaryButtonText: "Cancel",
      primaryButtonText: "Save tags",
      onOnCloseClick: _cache[3] || (_cache[3] = ($event: any) => ($options.toggleModal(false))),
      onOnSecondaryClick: _cache[4] || (_cache[4] = ($event: any) => ($options.toggleModal(false))),
      onOnPrimaryClick: $options.handleSaveTags
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createVNode(_component_NrSelect, {
            options: $options.filteredTags,
            modelValue: $data.requestTags,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.requestTags) = $event)),
            placeholder: "Search for tags",
            onSearch: $options.handleTagSearch,
            filterable: false,
            "append-to-body": "",
            multiple: "",
            onLoadMore: $options.handleTagScroll,
            loading: _ctx.dataFetchState.tags.fetching,
            hasMore: !_ctx.dataFetchState.tags.end,
            onOpen: $options.handleTagSearch
          }, {
            label: _withCtx(() => [
              _createTextVNode("Tags")
            ]),
            _: 1
          }, 8, ["options", "modelValue", "onSearch", "onLoadMore", "loading", "hasMore", "onOpen"]),
          ($options.canUpdateRequest)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(" Don't see a tag you need? Create one via the "),
                _hoisted_9,
                _createTextVNode(". ")
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _: 1
    }, 8, ["show", "disableButtons", "onOnPrimaryClick"])
  ]))
}